<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <br />
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-1/2 mt-5">
        Nome do Arquivo: {{ fileName }}
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col mt-5">
        <input
          type="file"
          class="hidden"
          ref="attachmentInput"
          @change="attachFile($event)"
          accept="application/pdf"
          name="file"
        />
        <vs-button color="primary" @click="$refs['attachmentInput'].click()">
          {{ currentAttachment.name || "Selecione um arquivo" }}
        </vs-button>
      </div>
      <div class="vx-col mt-5" v-if="showSaveButton">
        <vs-button color="success" @click="submitData()"> Salvar </vs-button>
      </div>
    </div>

    <br />
    <br />
    <div id="data-list-thumb-view" class="data-list-container">
      <vs-table
        ref="tableContracts"
        v-model="contracts"
        pagination
        :max-items="itemsPerPageConfirmed"
        search
        :data="contracts"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div class="flex flex-wrap-reverse items-center"></div>
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div
              class="
                p-4
                border border-solid
                d-theme-border-grey-light
                rounded-full
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-between
                font-medium
              "
            >
              <span class="mr-2"
                >{{
                  currentPage * itemsPerPageConfirmed -
                  (itemsPerPageConfirmed - 1)
                }}
                -
                {{
                  contracts.length - currentPage * itemsPerPageConfirmed > 0
                    ? currentPage * itemsPerPageConfirmed
                    : contracts.length
                }}
                of {{ queriedItemsConfirmed }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPageConfirmed = 10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPageConfirmed = 20">
                <span>20</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <template slot="thead">
          <vs-th sort-key="name">Código</vs-th>
          <vs-th sort-key="code">Nome</vs-th>
          <vs-th sort-key="code">Visualizar</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr
              :data="contracts"
              :key="indextr"
              v-for="(contract, indextr) in data"
            >
              <vs-td>
                <p class="product-name font-medium truncate">
                  <vs-chip color="#1E90FF">
                    {{ contract.idGoldContract }}</vs-chip
                  >
                </p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ contract.name }}
                </p>
              </vs-td>
              <vs-td class="whitespace-no-wrap">
                <vx-prompt
                  title="Pré-visualização"
                  accept-text="Baixar"
                  color="success"
                  cancel-text="Abrir"
                  @accept="
                    downloadAttach(contract.name, contract.file, contract.type)
                  "
                  @cancel="openAttach(contract.file, contract.type)"
                  :ref="'vxPrompt-' + indextr"
                >
                  <span>{{ contract.nome }}</span>
                  <br />
                  <div v-if="contract.type == 'application/pdf'">
                    <span v-show="pageCount == 1">{{ pageCount }} página</span>
                    <span v-show="pageCount > 1">{{ pageCount }} páginas</span>
                    <pdfViewer
                      @num-pages="pageCount = $event"
                      :src="contract.file"
                    ></pdfViewer>
                  </div>
                </vx-prompt>
                <feather-icon
                  icon="EyeIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click="$refs['vxPrompt-' + indextr][0].togglePrompt(true)"
                />
                <feather-icon
                  icon="Trash2Icon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click="deleteFile(contract.idGoldContract )"
                />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { fileTools, momentJS } from "@/helpers";
import { baseApiUrl } from "@/global";
import { numberJS } from "@/helpers";
import SumOrders from "./component/SumOrders.vue";
import InfoOrder from "./component/InfoOrder";
import pdfViewer from "vue-pdf";
export default {
  components: { SumOrders, InfoOrder, pdfViewer },
  props: {
    idOrder: {},
  },
  data() {
    return {
      showSaveButton: false,
      fileName: "Nenhum Arquivo Selecionado",
      fileTools: null,
      currentAttachment: {},
      contracts: [],
      itemsPerPageConfirmed: 10,
      itemsPerPage: 30,
      isMounted: false,
      showAttachDialog: false,
      pageCount: 0,
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.tableContracts.currentx;
      }
      return 0;
    },
    queriedItemsConfirmed() {
      return this.$refs.tableContracts
        ? this.$refs.tableContracts.queriedResults.length
        : this.contracts.length;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.getProducts.length;
    },
  },
  methods: {
    async openAttach(base64, type) {
      //console.log(base64);
      //console.log(type);
      const response = await axios.get(base64, {
        responseType: "blob",
      });
      //console.log(response)
      const blobUrl = URL.createObjectURL(response.data, { type });
      window.open(blobUrl, "_blank");
    },
    async downloadAttach(name, base64, type) {
      const response = await axios.get(base64, {
        responseType: "blob",
      });
      const blobUrl = URL.createObjectURL(response.data, { type });
      const fileElement = document.createElement("a");
      fileElement.href = blobUrl;
      fileElement.download = name;
      fileElement.click();
    },
    async submitData() {
      try {
        this.$vs.loading();
        let response = await axios.post(
          `${baseApiUrl}/goldOrder/uploadContract`,
          this.currentAttachment
        );
        console.log(this.currentAttachment);
        this.$vs.notify({
          title: "Salvo",
          text: "com Sucesso",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });

        this.fileName = "Nenhum Arquivo Selecionado";
        this.showSaveButton = false;
        Object.assign(response.data, { file: this.currentAttachment.file });
        this.contracts.push(response.data);
        this.currentAttachment = {};
      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel anexar os arquivos",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async attachFile(event) {
      this.showSaveButton = true;
      const attachment = event.target.files;
      if (!attachment.length) return;
      this.currentAttachment.file = await this.fileTools.toBase64(
        attachment[0]
      );
      this.currentAttachment.name = attachment[0].name;
      this.currentAttachment.type = attachment[0].type;
      this.currentAttachment.fk_goldOrder = this.idOrder;
      this.fileName = this.currentAttachment.name;
      (this.currentAttachment.fk_idUser = this.$store.state.user.idUser),
        (this.currentAttachment.createAt = momentJS().getDateTime());
    },

    getOrderStatusColor(status) {
      if (status == "on_hold") return "warning";
      if (status == "delivered") return "success";
      if (status == "canceled") return "danger";
      return "primary";
    },
    getPopularityColor(num) {
      if (num > 90) return "success";
      if (num > 70) return "primary";
      if (num >= 50) return "warning";
      if (num < 50) return "danger";
      return "primary";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    async deleteFile(idGoldContract) {
      try {
        this.$vs.loading();
        await axios.post(`${baseApiUrl}/goldOrder/deleteContract`, {
          idGoldContract,
        });
      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel apagar os arquivos",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      } finally {
        this.$vs.loading.close();
      }
      await this.loadContracts();
    },
    async loadContracts() {
      try {
        this.$vs.loading();
        let response = await axios.get(
          `${baseApiUrl}/goldOrder/getContractByIdGoldOrder/${this.$route.params.idOrder}`
        );
        this.contracts = response.data;
      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel carregar os arquivos",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  async created() {
    this.fileTools = fileTools();
    this.momentJS = momentJS();
    await this.loadContracts();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
